import "./App.css";
import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import PreLogin from "./pages/SignIn/PreLogin";
import RegistrationForm from "./pages/SignIn/RegistrationForm";
import PhibroSignIn from "./pages/SignIn/PhibroSignIn";
import ForgotPassword from "./pages/SignIn/ForgotPassword";
import VerifyEmail from "./pages/SignIn/VerifyEmail";
import CustomerLogin from "./pages/SignIn/CustomerLoginPage";
import PreLoginFaq from "./pages/SignIn/PreLoginFaq";

import Dashboard from "./pages/Dashboard/Dashboard";
import Scheduler from "./pages/Lab Admin Tabs/Scheduler/Scheduler";
import Tasks from "./pages/Lab Admin Tabs/Tasks/Tasks";
import ScanSample from "./pages/Lab Admin Tabs/ScanSample/ScanSample";
import Reports from "./pages/Lab Admin Tabs/Reports/Reports";
import RequestedList from "./pages/Lab Admin Tabs/RequestedList/RequestedList";

import GlobalDashboard from "./pages/Global Dashboard/GlobalDashboard";
import UserManagement from "./pages/User Management/UserManagement";
import SupportManagement from "./pages/Support Management/SupportManagement";
import CompanyManagement from "./pages/Company Management/CompanyManagement";

import CustomerDashboard from "./pages/Customer/CustomerDashboard/CustomerDashboard";
import RequestFeedAssay from "./pages/Customer/Request Feed Assay/RequestFeedAssay";
import PrintPreview from "./pages/Customer/Print Preview/PrintPreview";
import AssayRequestRecord from "./pages/Customer/Assay Request Record/AssayRequestRecord";
import Settings from "./pages/Customer/Setting/Settings";
import FeedAssayPortalFaqs from "./pages/Customer/FAQ/FeedAssayPortalFaqs";
import CustomerReport from "./pages/Customer/CustomerReport/CustomerReport";
import Notification from "./pages/Customer/Notification/Notification";

import { RoleContext } from "./RoleContext";
import Unauthorized from "./pages/Unauthorized Page/Unauthorized";
import ProtectedRoute from "./ProtectedRoutes";
import PageNotFound from "./pages/PageNotFound/PageNotFound";
import LayoutRoute from "./components/organisms/LayoutRoute/LayoutRoute";

import StaffDashboard from "./pages/Field Staff Tabs/Dashboard/StaffDashboard";
import StaffRequestList from "./pages/Field Staff Tabs/Request List/StaffRequestList";
import AnalystDashboard from "./pages/Lab Analyst Tabs/DashBoard/AnalystDashboard";
import AnalystScheduler from "./pages/Lab Analyst Tabs/Scheduler/AnalystScheduler";
import MyAssignment from "./pages/Lab Analyst Tabs/Analyst Tasks/MyAssignment";
import AnalystPeerReview from "./pages/Lab Analyst Tabs/Analyst Tasks/AnalystPeerReview";
import AnalystRequestedList from "./pages/Lab Analyst Tabs/RequestedList/AnalystRequestedList";
import ReportsAnalyst from "./pages/Lab Analyst Tabs/Reports/ReportsAnalyst";
import {
  LabAdminTabConfig,
  LabAnalystTabConfig,
  CompanyManagementTabConfig,
  AnalystCompanyManagementTabConfig,
  CustomerReportTabConfig,
  AssayRequestTabConfig,
} from "./Constants";
import AnalystCompanyManagement from "./pages/Lab Analyst Tabs/CompanyManagement/AnalystCompanyManagement";
import AnalystScanSample from "./pages/Lab Analyst Tabs/Scan Sample/AnalystScanSample";

import { NotificationProvider } from "./pages/Customer/Notification/NotificationProvider";
import AdminPrintPreview from "./pages/Lab Admin Tabs/PrintPreview/AdminPrintPrieview";
import HistoricalData from "./pages/Lab Admin Tabs/HistoricalData/HistoricalData";

function App() {
  const [role, setRole] = useState("");
  const [name, setName] = useState("");
  const [roleOptions, setRoleOptions] = useState([]);

  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const currentRole = localStorage.getItem("currentRole");
    if (userData && userData !== "undefined" && userData !== "null") {
      const parsedUserData = JSON.parse(userData);
      const { name, roleName } = parsedUserData || {};
      setRoleOptions(roleName || []);

      setRole(
        currentRole
          ? JSON.parse(currentRole)
          : roleName && roleName[0]
            ? roleName[0]
            : ""
      );
      setName(name || "");
    }
  }, []);

  return (
    <RoleContext.Provider
      value={{ role, setRole, roleOptions, setRoleOptions, name }}
    >
      <ToastContainer position="top-right" autoClose={3000} />
      <NotificationProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<PreLogin />} />
          <Route path="/prelogin" element={<PreLogin />} />
          <Route path="/login" element={<PhibroSignIn />} />
          <Route path="/registrationForm" element={<RegistrationForm />} />
          <Route path="/update-password" element={<VerifyEmail />} />
          <Route path="/forgot-Password" element={<ForgotPassword />} />
          <Route path="/customer-Login" element={<CustomerLogin />} />
          <Route path="/faqs" element={<PreLoginFaq />} />

          {/* Unauthorized */}
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* ---------- Lab Admin Routes ---------- */}
          <Route element={<LayoutRoute />}>
            <Route element={<ProtectedRoute allowedRoles={["Lab Admin", "IT Admin"]} />}>
              <Route
                path="/admin-dashboard"
                element={<Dashboard TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/scheduler"
                element={<Scheduler TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/tasks"
                element={<Tasks TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/scan-sample"
                element={<ScanSample TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/reports"
                element={<Reports TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/historical-data"
                element={<HistoricalData TabConfig={LabAdminTabConfig} />}
              />
              <Route
                path="/requested"
                element={<RequestedList TabConfig={LabAdminTabConfig} />}
              />
              <Route path="/user-management" element={<UserManagement />} />
              <Route
                path="/support-management"
                element={<SupportManagement />}
              />
              <Route
                path="/company-management"
                element={
                  <CompanyManagement TabConfig={CompanyManagementTabConfig} />
                }
              />
              <Route
                path="/company-management/print-preview"
                element={<AdminPrintPreview />}
              />
            </Route>

                   <Route element={<ProtectedRoute allowedRoles={["Customer", "Lab Admin", "Analyst", "IT Admin"]} />}>
                    <Route path="/request-feed-assay" element={<RequestFeedAssay />} />
                   </Route>


            {/* ---------- Customer Routes ---------- */}
            <Route element={<ProtectedRoute allowedRoles={["Customer"]} />}>
              <Route path="/customer-dashboard" element={<CustomerDashboard />} />
              <Route
                path="/assay-request-record"
                element={<AssayRequestRecord TabConfig={AssayRequestTabConfig} />}
              />
              <Route
                path="/request-feed-assay/print-preview"
                element={<PrintPreview />}
              />
              <Route
                path="/assay-request-record/print-preview"
                element={<PrintPreview />}
              />
              <Route path="/faq" element={<FeedAssayPortalFaqs />} />
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/customer-reports"
                element={<CustomerReport TabConfig={CustomerReportTabConfig} />}
              />
              <Route path="/notification" element={<Notification />} />
            </Route>

            {/* ---------- Analyst Routes ---------- */}
            <Route element={<ProtectedRoute allowedRoles={["Analyst"]} />}>
               <Route
                path="/analyst-companyManagement/print-preview"
                element={<AdminPrintPreview />}
              />
              <Route
                path="/analyst-dashboard"
                element={<AnalystDashboard TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-scan-sample"
                element={<AnalystScanSample TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-scheduler"
                element={<AnalystScheduler TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-tasks/myassignment"
                element={<MyAssignment TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-tasks/peer-review"
                element={<AnalystPeerReview TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-requested"
                element={<AnalystRequestedList TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-reports"
                element={<ReportsAnalyst TabConfig={LabAnalystTabConfig} />}
              />
              <Route
                path="/analyst-companyManagement"
                element={
                  <AnalystCompanyManagement
                    TabConfig={AnalystCompanyManagementTabConfig}
                  />
                }
              />
            </Route>

            {/* ---------- Field Staff Routes ---------- */}
            <Route element={<ProtectedRoute allowedRoles={["Field Staff"]} />}>
              <Route path="/field-staff-dashboard" element={<StaffDashboard />} />
              <Route path="/field-staff-request-list" element={<StaffRequestList />} />
            </Route>
          </Route>

          {/* ---------- Global Dashboard ---------- */}
          <Route element={<ProtectedRoute allowedRoles={["Lab Admin", "IT Admin"]} />}>
            <Route path="/global-dashboard" element={<GlobalDashboard />} />
          </Route>

          {/* ---------- 404 ---------- */}
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </NotificationProvider>
    </RoleContext.Provider>
  );
}

export default App;
